export default __webpack_public_path__ + "static/media/1234567.1946ecf5.png";